
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { ChevronRight } from "lucide-react";

export function GetStartedSection() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  return (
    <section className="py-16 bg-gradient-to-t from-background to-muted/20">
      <div className="container max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-5">Start Using Hour Tracker Today</h2>
        <p className="text-lg text-muted-foreground mb-8 px-4 md:px-8 max-w-2xl mx-auto">
          Join thousands of professionals who streamline their workflow with Hour Tracker.
          Start your subscription today.
        </p>
        <Button 
          size={isMobile ? "lg" : "default"} 
          onClick={() => navigate("/auth")} 
          className="group w-full sm:w-auto px-8 py-6 sm:py-4 shadow-md hover:shadow-lg transition-all duration-300"
        >
          <span className="text-base md:text-lg">Get Started</span>
          <ChevronRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Button>
      </div>
    </section>
  );
}
